import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "今日热榜", anchor: "hot", icon: "ri-fire-line" },
  { label: "最新速览", anchor: "latest", icon: "ri-flashlight-line" },
  { label: "深度解析", anchor: "deep", icon: "ri-search-line" },
  { label: "分类热词", anchor: "topics", icon: "ri-price-tag-3-line" },
  { label: "关于我们", anchor: "about", icon: "ri-question-answer-line" },
];

export default function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSection = (anchor: string) => {
    setMenuOpen(false);
    const scroll = () => {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (!onHome) {
      navigate("/");
      window.setTimeout(scroll, 120);
    } else {
      scroll();
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? "border-background-200/80 bg-background-50/90 backdrop-blur-md"
          : "border-background-200/60 bg-background-50/60 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        {/* 品牌 */}
        <Link
          to="/"
          aria-label="吃瓜资讯 首页"
          className="group flex items-center gap-2.5"
          onClick={() => setMenuOpen(false)}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-display text-xl text-background-50 shadow-sm transition-transform group-hover:-rotate-6">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl text-primary-700">吃瓜资讯</span>
            <span className="text-[11px] tracking-wide text-foreground-500">
              事件梳理 · 深度解析 · 完整时间线
            </span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.anchor}
              href={`#${item.anchor}`}
              onClick={(e) => {
                e.preventDefault();
                goSection(item.anchor);
              }}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              <i className={`${item.icon} text-base`} aria-hidden="true"></i>
              {item.label}
            </a>
          ))}
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              goSection("subscribe");
            }}
            className="ml-2 flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-add-line text-base" aria-hidden="true"></i>
            追瓜提醒
          </Link>
        </nav>

        {/* 移动端按钮 */}
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 md:hidden"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {/* 移动端菜单 */}
      {menuOpen && (
        <nav
          className="border-t border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur-md md:hidden"
          aria-label="移动导航"
        >
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.anchor}
                href={`#${item.anchor}`}
                onClick={(e) => {
                  e.preventDefault();
                  goSection(item.anchor);
                }}
                className="flex items-center gap-2.5 rounded-lg px-3 py-3 text-sm text-foreground-700 hover:bg-primary-100"
              >
                <i className={`${item.icon} text-lg text-primary-500`} aria-hidden="true"></i>
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                goSection("subscribe");
              }}
              className="mt-1 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-mail-add-line text-lg" aria-hidden="true"></i>
              订阅追瓜提醒
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}